// This file exports an array of recommended books for mental health and emotional well-being.
// The data is used in the <BookList /> component, which maps over this array to display a list of clickable resources.

const recommendedBooks = [
  {
    title: "Adult Children of Emotionally Immature Parents",
    author: "Lindsay Gibson",
    link: "https://a.co/d/61YIUVk",
  },
  {
    title: "Boundaries",
    author: "Henry Cloud and John Townsend",
    link: "https://a.co/d/60146Yf",
  },
  {
    title: "CoDependent No More",
    author: "Melody Beattie",
    link: "https://a.co/d/5xTvssM",
  },
  {
    title: "Forgiving What You Can't Forget",
    author: "Lysa Terkeurst",
    link: "https://a.co/d/3GhtUrr",
  },
  {
    title: "Good Boundaries and Goodbyes",
    author: "Lysa Terkeurst",
    link: "https://a.co/d/fZeeTbM",
  },
  {
    title: "It Didn't Start with You",
    author: "Mark Wolynn",
    link: "https://a.co/d/77FAXLC",
  },
  {
    title: "It's Not You",
    author: "Ramani Darvasula",
    link: "https://a.co/d/7AWwzGi",
  },
  {
    title: "Reclaim Your Life: Acceptance and Commitment Therapy in 7 Weeks",
    author: "Carissa Gustafson, PsyD",
    link: "https://a.co/d/3kKPUU7",
  },
  {
    title: "Rewire Your Anxious Brain",
    author: "Catherine Pittman, PhD and Elizabeth Karle, MLIS",
    link: "https://a.co/d/dvGZeEZ",
  },
  {
    title: "Safe People",
    author: "Henry Cloud and John Townsend",
    link: "https://a.co/d/5jegV13",
  },
  {
    title: "Take Charge of Bipolar Disorder",
    author: "Julie A Fast and Pohn Preston",
    link: "https://a.co/d/5zmqI5v",
  },
  {
    title: "Talking Back to OCD",
    author: "John March, MD and Christine M Benton",
    link: "https://a.co/d/ijl6mLB",
  },
  {
    title: "The Body Keeps the Score",
    author: "Bessel Van Der Kolk MD",
    link: "https://a.co/d/a0QbJmm",
  },
  {
    title: "The Gifts of Imperfection",
    author: "Brene Brown",
    link: "https://a.co/d/aV7EAlZ",
  },
  {
    title: "The Hidden Peace",
    author: "Joel Mudamalle",
    link: "https://a.co/d/eLMJvrO",
  },
  {
    title: "Try Softer",
    author: "Aundi Kobler",
    link: "https://a.co/d/colsB6q",
  },
    {
    title: "When to Walk Away",
    author: "Gary Thomas",
    link: "https://a.co/d/i16LSqV",
  },
  {
    title: "When to Walk Away",
    author: "Gary Thomas",
    link: "https://a.co/d/i16LSqV",
  },
  {
    title: "Untangle Your Emotions",
    author: "Jennie Allen",
    link: "https://a.co/d/3qq2FSy",
  },
  // Template for adding more books:
  // {
  //   title: "",
  //   author: "",
  //   link: "",
  // },
];

export default recommendedBooks;